import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
	DownloadOutlined,
	EyeOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import HttpService from "../services/httpService";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { useSelector } from "react-redux";
import {
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	FormControlLabel,
	Checkbox,
	TextField,
} from "@material-ui/core";
import { ROLENAME } from "../utils/index";
const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 700,
	},
	formControl: {
		margin: theme.spacing(3),
	},
	root: {
		display: "flex",
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#3F51B5",
		color: "#FFF",
		fontWeight: "1000",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const SoStdRateDetailsModal = (props) => {
	const classes = useStyles();
	const { userDetails } = useSelector((state) => state.user);
	const [soDetails, setSoDetails] = useState();
	const [remarks, setRemarks] = useState("");

	// Function to update the status of SO's
	const editServiceOrderStatus = async (status) => {
		props.setLoading(true);
		try {
			let data = {
				materialElementId: soDetails?.materials[0]?._id,
				materialId: soDetails?.materials[0]?.materialId?._id,
				requestedPrice: soDetails?.materials[0]?.price,
				pricePerUnit: soDetails?.materials[0]?.vendorPrice,
				requestedQuantity: soDetails?.materials[0]?.requestedQuantity,
				projectId: props?.SELECTEDPROJECT?._id ?? soDetails?.projectId?._id,
				projectMaterialId: soDetails?.materials[0]?.projectMaterialId,
				quantity: soDetails?.materials[0]?.quantity,
				scopeId: soDetails?.scopeId?._id,
				approveForCurrentPo: soDetails?.materials[0]?.approveForCurrentSo,
				updateStandardRateOfMaterial:
					soDetails?.materials[0]?.updateStandardRateOfMaterial,
				operationHeadApproved: soDetails?.materials[0]?.operationHeadApproved,
				status: status,
				vendorId: soDetails?.materials[0]?.vendorId,
			};

			if (
				soDetails?.materials[0].approveForCurrentSo &&
				soDetails?.materials[0].updateStandardRateOfMaterial &&
				soDetails?.materials[0].operationHeadApproved
			) {
				const result = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					data
				);
				if (result.status === 200) {
					props.setSnackInfo("SO Approved & Std Rate Updated", "success");
					props.REFRESH(soDetails?.orderId);
				}
			}
			if (
				soDetails?.materials[0].approveForCurrentSo &&
				!soDetails?.materials[0].updateStandardRateOfMaterial
			) {
				const result = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					data
				);
				if (result.status === 200) {
					props.setSnackInfo(`Service order ${status}`, "success");
					props.REFRESH(soDetails?.orderId);
				}
			}
		} catch (error) {
			console.error(error);
			props.setSnackInfo(
				error?.response?.data?.message ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
	};

	// Function to download masked SO
	const getMaskedSODocument = async (data) => {
		props.setLoading(true);
		try {
			const result = await HttpService.generateMaskedSo(data._id);
			window.open(result.data.link);
		} catch (error) {
			console.error(error, "error");
		}
		props.setLoading(false);
	};

	const [rejectOpenModel, setRejectOpenModel] = useState(false);

	const rejectSo = (status) => {
		setRejectOpenModel(true);
	};

	// Function to reject a SO
	const rejectSoConfirm = async () => {
		props.setLoading(true);
		try {
			if (remarks === "") {
				props.setSnackInfo("Please Enter your remark", "error");
			} else {
				let obj = {
					status: "Rejected",
					remarks: {
						date: new Date(),
						action: remarks,
						userId: userDetails._id,
					},
				};
				let response = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					obj
				);
				props.setSnackInfo(response?.data ?? "Something went wrong", "success");
				setRejectOpenModel(false);
				setRemarks("");
				props.VIEWALL();
			}
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data?.message ?? "Error", "error");
		}
		props.setLoading(false);
	};

	// Function to handle checkbox checking for "approveCurrentPoCheck"
	const approveCurrentSoCheckHandler = (event, index) => {
		let arr = { ...soDetails };
		arr.materials[index].approveForCurrentSo =
			arr.materials[index].approveForCurrentSo;
		setSoDetails(arr);
	};

	// Function to handle checkbox checking for "updateStdRateCheck"
	const updateStdRateCheckHandler = (event, index) => {
		let arr = { ...soDetails };
		arr.materials[index].updateStandardRateOfMaterial =
			!arr.materials[index].updateStandardRateOfMaterial;
		setSoDetails(arr);
	};

	useEffect(() => {
		setSoDetails(props?.SODETAILS);
	}, [props?.SODETAILS]);

	return (
		<div>
			<div className="modal-header" style={{ justifyContent: "space-between" }}>
				<div style={{ width: "25%" }}>
					<b>Project: </b>
					<span>{`${soDetails?.projectId?.code}_${soDetails?.projectId?.clientName}`}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Scope: </b>
					<span>{soDetails?.scopeId?.name}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Vendor Name: </b>
					<span>{soDetails?.vendorId?.name}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Vendor Mobile: </b>
					<span>{soDetails?.vendorId?.contactNumber}</span>
				</div>
			</div>
			<div className="modal-header" style={{ justifyContent: "space-between" }}>
				<div style={{ width: "25%" }}>
					<b>Expected Delivery Date: </b>
					<span>{soDetails?.deliveryDate}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Status: </b>
					<span>{soDetails?.status}</span>
				</div>
				<div style={{ width: "15%" }}>
					<span className="btn" onClick={() => props.VIEWALL()}>
						View All <EyeOutlined />
					</span>
					<br />
					<br />
				</div>
			</div>
			{props.TITLE === "Approve SO" &&
				soDetails?.materials[0]?.operationHeadApproved &&
				soDetails?.status !== "Approved" &&
				soDetails?.status !== "Rejected" &&
				soDetails?.status !== "SO Generated" && (
					<div className="approve-reject-btn">
						<button
							onClick={() => editServiceOrderStatus("Approved")}
							className="approve-btn"
						>
							Approve
						</button>
						<button onClick={() => rejectSo("Rejected")} className="reject-btn">
							Reject
						</button>
					</div>
				)}
			<TableContainer component={Paper}>
				<Table
					className={classes.table}
					size="small"
					aria-label="customized table"
				>
					<TableHead>
						<TableRow>
							<StyledTableCell>Sl No</StyledTableCell>
							<StyledTableCell>Product</StyledTableCell>
							{/* <StyledTableCell>Category</StyledTableCell>. */}
							<StyledTableCell>Unit</StyledTableCell>
							<StyledTableCell>Area/Qty</StyledTableCell>
							<StyledTableCell>Requested Area/Qty</StyledTableCell>
							<StyledTableCell>Vendor Rate</StyledTableCell>
							<StyledTableCell>Requested Rate</StyledTableCell>
							{/* <StyledTableCell>Decorpot Price</StyledTableCell> */}
							{/* <StyledTableCell>Quotation file</StyledTableCell> */}
							{/* <StyledTableCell>Remarks</StyledTableCell> */}
							{soDetails?.status !== "Approved" &&
								soDetails?.status !== "Rejected" &&
								soDetails?.status !== "SO Generated" && (
									<>
										{/* <StyledTableCell align="center">
											Approve For Current SO
										</StyledTableCell> */}
										<StyledTableCell align="center">
											Update Std Rate Card
										</StyledTableCell>
									</>
								)}
						</TableRow>
					</TableHead>
					<TableBody>
						{soDetails?.materials?.map((data, i) => (
							<StyledTableRow StyledTableRow key={i + 1}>
								<StyledTableCell>{i + 1}</StyledTableCell>
								<StyledTableCell>{data?.materialId?.name}</StyledTableCell>
								{/* <StyledTableCell>{data?.category}</StyledTableCell> */}
								<StyledTableCell>{data?.unitId?.name}</StyledTableCell>
								<StyledTableCell>
                                    {parseFloat(
										data?.requestedQuantity || data?.quantity
									).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.vendorRate || data?.vendorPrice).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.price).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{data?.vendorPrice}
								</StyledTableCell>
								{/* <StyledTableCell>{data?.decorpotPrice}</StyledTableCell> */}
								{/* <StyledTableCell>{data?.file}</StyledTableCell> */}
								{/* <StyledTableCell>{data?.remark}</StyledTableCell> */}
								{soDetails?.status !== "Approved" &&
									soDetails?.status !== "Rejected" &&
									soDetails?.status !== "SO Generated" && (
										<>
											{/* <StyledTableCell>
												<FormControlLabel
													onChange={(e) => approveCurrentSoCheckHandler(e, i)}
													control={
														<Checkbox checked={data?.approveForCurrentSo} />
													}
													label=""
												/>
											</StyledTableCell> */}
											<StyledTableCell>
												<FormControlLabel
													onChange={(e) => updateStdRateCheckHandler(e, i)}
													control={
														<Checkbox
															checked={data?.updateStandardRateOfMaterial}
														/>
													}
													label=""
												/>
											</StyledTableCell>
										</>
									)}
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
			<div>
				<Dialog
					open={rejectOpenModel}
					onClose={() => setRejectOpenModel(false)}
					aria-labelledby="form-dialog-title"
					maxWidth="sm"
					fullWidth
				>
					<DialogContent>
						<DialogContentText>Enter Remarks For Rejection</DialogContentText>
						<TextField
							id="remarks"
							name="Remarks"
							label="Add Remarks"
							variant="outlined"
							type="text"
							value={remarks}
							onChange={(e) => setRemarks(e.target.value)}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button
							variant="outlined"
							onClick={() => setRejectOpenModel(false)}
							color="secondary"
						>
							Cancel
						</Button>
						<Button
							onClick={rejectSoConfirm}
							variant="outlined"
							color="primary"
						>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(
	SoStdRateDetailsModal
);